import React from 'react'
export const NewUserTag =
  <small className="ml-1">
    <span
      className="badge badge-success"
      // data-delay={{'show': 250, 'hide': 0}}
      data-placement="right"
      data-toggle="tooltip"
      data-trigger="hover"
      title="Profile is less than 15 days old"
    >
      New Profile
        </span>
  </small>

